import html2pdf from "html2pdf.js";
import { message } from "antd";
import { renderQuotation } from "../../../components/templates";

export const sanitizeFileName = (value: string): string => {
  return value.replace(/[<>:"/\\|?*\x00-\x1f]/g, "_").trim() || "quotation";
};

interface QuotationConfig {
  storeName: string;
  address: string;
  phone: string;
  currency: string;
  receiptFooter: string;
}

export const getQuotationHtml = (
  q: any,
  config: QuotationConfig,
  isForPrint = true,
): string => {
  return renderQuotation({
    quotation: {
      id: q.id,
      quotation_name: q.quotation_name,
      created_at: q.created_at,
      customer_id: q.customer_id,
      customer_name: q.customer_name,
      customer_phone: q.customer_phone,
      customer_email: q.customer_email,
      customer_address: q.customer_address,
      temp_customer_name: q.temp_customer_name,
      temp_customer_phone: q.temp_customer_phone,
      temp_customer_email: q.temp_customer_email,
      temp_customer_address: q.temp_customer_address,
      cart_data: q.cart_data || [],
      status: q.status,
    },
    config: {
      store_name: config.storeName,
      address: config.address,
      phone: config.phone,
      currency: config.currency,
      receipt_footer: config.receiptFooter,
    },
    pageSize: "A4",
    isForPrint,
    validityDays: 30,
  });
};

export const handlePrint = (q: any, config: QuotationConfig): void => {
  const frame = document.createElement("iframe");
  frame.style.cssText = "position:absolute;top:-9999px;left:-9999px;";
  document.body.appendChild(frame);

  const doc = frame.contentWindow?.document || frame.contentDocument;
  if (!doc) {
    if (frame.parentNode) frame.parentNode.removeChild(frame);
    return;
  }

  doc.open();
  doc.write(getQuotationHtml(q, config, true));
  doc.close();

  window.setTimeout(() => {
    frame.contentWindow?.focus();
    frame.contentWindow?.print();
    window.setTimeout(() => {
      if (frame.parentNode) frame.parentNode.removeChild(frame);
    }, 1000);
  }, 500);
};

export const handleDownload = (q: any, config: QuotationConfig): void => {
  const container = document.createElement("div");
  container.innerHTML = getQuotationHtml(q, config, false);

  html2pdf()
    .from(container)
    .set({
      filename: `Quotation_${sanitizeFileName(q.quotation_name || q.id)}.pdf`,
      margin: 10,
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
    })
    .save();

  message.success("Quotation PDF downloaded!");
};
